<template>
  <q-layout view="hHr LpR lFf">
    <q-header elevated bordered>
      <q-toolbar class="bg-primary gemunu text-white">
        <q-toolbar-title class="text-h3 q-py-sm">
          <q-img
            src="../../../assets/logo_gestaosistema.png"
            width="250px"
          />
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <div class="">
        <div class="boasVindas">
          <div class="q-my-md text-h6 text-bold">Seja bem vindo!</div>
          <div class="text-subtitle1">Estamos felizes com sua iniciativa de melhorar a gestão de seu empreendimento</div>
        </div>

        <div class="row justify-center">
          <div class="credenciais text-left q-my-xl">
            <div>Abaixo estão suas credenciais para acessar o Sistema:</div>
            <div class="q-ml-md">
              Endereço de acesso: 
              <a href="https://gestaoesportes.com.br">www.gestaoesportes.com.br</a>
            </div>
            <div class="q-ml-md">Usuário: <b>"E-Mail"</b></div>
            <div class="q-ml-md">Senha Inicial: <i>gestaoesportes</i></div>
          </div>
        </div>
        
        <div class="contatos">
          <div>Guarde nossos contatos:</div>
          <div>Renan  (32) 9 8806-8494</div>
          <div>Wesley (62) 9 9207-6671</div>
        </div>
      </div>
    </q-page-container>

    <q-footer elevated bordered>
      <div class="row justify-around">
        <a class="hoverLink" href="https://www.instagram.com/faturesistemas/">
          <q-icon size="md" class="q-my-md" name="fab fa-instagram" />
        </a>
        <a class="hoverLink" href="https://www.youtube.com/channel/UChywQSq_Pun4r3U857IQZCA">
          <q-icon size="md" class="q-my-md" name="fab fa-youtube" />
        </a>
        <a class="hoverLink" href="https://api.whatsapp.com/send?phone=5532988068494&text=Olá, gostaria de mais informações sobre o Sistema!">
          <q-icon size="md" class="q-my-md" name="fab fa-whatsapp" />
        </a>
      </div>
    </q-footer>
  </q-layout>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
  .credenciais {
    width: 370px;
  }

  .hoverLink {
    color: white;
  }
  .hoverLink:hover {
    text-decoration: none;
  }
</style>